module.exports = "/static-assets/_next/static/images/paper-note-218d58be67e2b7bae79293d1437c3a40.png";